export default [
  {
    path: 'clients/',
    component: () => import('src/pages/clients/Index.vue'),
    children: [
      {
        path: 'list',
        name: 'listClients',
        component: () => import('src/pages/clients/List.vue'),
      },
      {
        path: 'equipment-reports',
        name: 'adminClientEquipmentReports',
        component: () => import('src/components/EquipmentReports/EquipmentReports.vue'),
      },
      {
        path: 'create',
        name: 'createClients',
        component: () => import('src/pages/clients/Create.vue'),
      },
      {
        path: 'SpecialDays',
        name: 'SpecialDays',
        component: () => import('src/pages/clients/SpecialDays.vue'),
      },
      {
        path: 'edit/:id/',
        alias: 'edit/:id',
        name: 'editClients',
        component: () => import('src/pages/clients/Edit.vue'),
        redirect: { name: 'adminClientBase' },
        children: [
          {
            path: 'base',
            name: 'adminClientBase',
            component: () => import('src/pages/clients/components/base.vue'),
          },
          {
            path: 'taches',
            name: 'adminClientAvis',
            component: () => import('src/pages/clients/components/taches/index.vue'),
          },
          {
            path: 'horaire',
            name: 'adminClientHoraire',
            component: () => import('src/pages/Horaire/index.vue'),
          },
          {
            path: 'incidents',
            name: 'adminClientIncidents',
            component: () => import('src/pages/clients/components/incidents/index.vue'),
          },
          {
            path: 'inventory',
            name: 'adminClientInventory',
            component: () => import('src/pages/clients/components/inventory/index.vue'),
          },
          {
            path: 'equipement',
            name: 'adminEquipment',
            component: () => import('src/pages/clients/components/equipment/index.vue'),
          },

          /*,
          {
            path: 'formations',
            name: 'adminClientformations',
            component: () => import('src/pages/clients/components/formations.vue')
          },
          {
            path: 'fichiers',
            name: 'adminClientfichiers',
            component: () => import('src/pages/clients/components/fichiers.vue')
          }*/
        ],
      },
      {
        path: 'view/:id/',
        name: 'viewClients',
        component: () => import('src/pages/clients/View.vue'),
        props: true,
      },
    ],
  },
]
